import client from "./client";
import {
  UnionHolidayWorkedConfig,
  PutUnionHolidayWorkedConfigBody,
} from "../interfaces/UnionHolidayWorked";

function getErrorMessage(err: unknown): string {
  if (err && typeof err === "object" && "response" in err) {
    const r = (err as { response?: { data?: { message?: string } } }).response;
    if (r?.data?.message) return r.data.message;
  }
  if (err instanceof Error) return err.message;
  return "Request failed";
}

export async function getUnionHolidayWorkedConfigs(): Promise<UnionHolidayWorkedConfig[]> {
  const response = await client.get<UnionHolidayWorkedConfig[]>(
    "admin/union/holidayWorked"
  );
  return response.data;
}

export async function getUnionHolidayWorkedConfig(
  locationID: number
): Promise<UnionHolidayWorkedConfig> {
  const response = await client.get<UnionHolidayWorkedConfig>(
    `admin/union/holidayWorked/${locationID}`
  );
  return response.data;
}

export async function putUnionHolidayWorkedConfig(
  locationID: number,
  body: PutUnionHolidayWorkedConfigBody
): Promise<UnionHolidayWorkedConfig> {
  const response = await client.put<UnionHolidayWorkedConfig>(
    `admin/union/holidayWorked/${locationID}`,
    body
  );
  return response.data;
}

export async function activateUnionHolidayWorkedConfig(
  locationID: number
): Promise<UnionHolidayWorkedConfig> {
  const response = await client.post<UnionHolidayWorkedConfig>(
    `admin/union/holidayWorked/${locationID}/activate`
  );
  return response.data;
}

export async function deactivateUnionHolidayWorkedConfig(
  locationID: number
): Promise<UnionHolidayWorkedConfig> {
  const response = await client.post<UnionHolidayWorkedConfig>(
    `admin/union/holidayWorked/${locationID}/deactivate`
  );
  return response.data;
}

export { getErrorMessage as getHolidayWorkedErrorMessage };
